import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Button, Spinner, Text, useColorMode } from "theme-ui";
import { createActionHighlight } from "../../../store/actions/action.Highlighters";

const ActionConfirmation = ({ Open, setOpen, selectedHighlight, actionObject, modalTitle = "Confirm Highlighter", confirmationMessage = "Are you sure you want to Add" }: any) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!Open) {
            setLoading(false);
        }
    }, [Open]);

    const togglePopover = () => {
        if (loading) return;
        setOpen(!Open);
    };
    const handleSubmit = () => {
        if (loading) return;
        setLoading(true);
        const payload = {
            actionType: selectedHighlight?.name,
            ...actionObject,
        }
        dispatch(createActionHighlight(payload, (res: any) => {
            setLoading(false);
            if (res.status === 200) {
                togglePopover();
            }
        }))

    }
    const [colorMode] = useColorMode();
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "black" : "#dadada";
    const closeButton = (
        <button
            type="button"
            aria-label="Close"
            onClick={togglePopover}
            style={{
                color: colorMode === 'dark' ? '#fff' : '#000',
                background: 'transparent',
                border: 'none',
                fontSize: 23,
                lineHeight: 1,
                padding: 0,
                cursor: 'pointer'
            }}
        >
            <span aria-hidden="true">&times;</span>
        </button>
    );
    return (
        <>
            <Modal isOpen={Open} toggle={togglePopover} size="sm" centered>
                <ModalHeader toggle={togglePopover} close={closeButton} style={{ backgroundColor: modalHeader, color: titleHeader }} >Confirm Highlighter</ModalHeader>
                <ModalBody style={{ backgroundColor: modalHeader }}>
                    <Text sx={{ color: titleHeader }}>Are you sure you want to Add <Text sx={{ fontWeight: 500 }}>{selectedHighlight?.name} </Text>highlighter?</Text>
                </ModalBody>
                <ModalFooter style={{ backgroundColor: modalHeader }}>
                    <Button variant="CancelButton" sx={{ mr: 2, cursor: loading ? 'not-allowed' : 'pointer' }} onClick={togglePopover} disabled={loading}>No</Button>
                    <Button type="button" variant="SaveButton" sx={{ cursor: loading ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={handleSubmit} disabled={loading}>
                        {loading ? <Spinner size={20} sx={{ color: 'white' }} /> : "Yes"}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default ActionConfirmation